import React, {CSSProperties} from 'react';
import IconButton from '../../ui/IconButton/IconButton';
import Icons from '../../ui/IconButton/Icons';
import TemplateTask from '../../entities/templateTask';
import {useInView} from 'react-intersection-observer';

function TaskTemplateItem(props: TaskTemplateItemProps) {
	const {ref, inView} = useInView();

	const {useChooser} = props;

	const onEdit = () => {
		props.onEdit(props.task);
	}
	const onDelete = () => {
		props.onDelete(props.task);
	}
	const onCreateTask = () => {
		props.onCreateTask(props.task);
	}

	const style: CSSProperties = props.task.global ? {} : {fontStyle: 'italic'};
	style.fontWeight = 'normal';

	const chooser = useChooser ? 'chooser' : ''

	if (useChooser) return <div ref={ref}
								className={`task-templates__item ${chooser}`}
								key={`tti${props.task.id}`}
	>
		<div className='task-templates__item-title-selectable'
			 style={style}
			 onClick={onCreateTask}
		>
			{props.task.title}
		</div>
	</div>;
	else return <div ref={ref} key={`tti${props.task.id}`}
					 className='task-templates__item'
	>

		<div className='task-templates__item-title'
			 style={style}
			 onClick={onEdit}
		>
			{props.task.title}
		</div>
		{inView && !useChooser && <IconButton type={Icons.EDIT} onClick={onEdit}/>}
		{inView && !useChooser && <IconButton type={Icons.DELETE} onClick={onDelete}/>}
		{inView && <IconButton type={Icons.ADD} onClick={onCreateTask}/>}
	</div>;
}

export type TaskTemplateItemProps = {
	task: TemplateTask,
	useChooser?: boolean,
	onCreateTask?: (task: TemplateTask) => void,
	onEdit?: Function,
	onDelete?: Function,
};

export default TaskTemplateItem;
